import { InnerQueryExpression } from "../InnerQueryExpression";

export class OrExpression implements InnerQueryExpression {
    public readonly $discriminator = "Or";
    public readonly expressions: InnerQueryExpression[];

    public constructor(expressions: InnerQueryExpression[]) {
        this.expressions = expressions;
    }
}
